var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstalledDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 1.2625L8.75 1.25C7.375 1.25 6.25 2.375 6.25 3.75V26.25C6.25 27.625 7.375 28.75 8.75 28.75H21.25C22.625 28.75 23.75 27.625 23.75 26.25V3.75C23.75 2.375 22.625 1.2625 21.25 1.2625ZM21.25 26.25H8.75V25H21.25V26.25ZM21.25 22.5H8.75V7.5H21.25V22.5ZM21.25 5H8.75V3.75H21.25V5ZM20 12.5625L18.2375 10.8L13.8125 15.225L12.05 13.4625L10.2875 15.225L13.8125 18.75L20 12.5625Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalledDevices);
export default __webpack_public_path__ + "static/media/Installed_Devices.15038a30994af65b822c42337318b171.svg";
export { ForwardRef as ReactComponent };